import styled from "styled-components";
import {
  elevation03,
  headerHeight,
  shade950,
  zIndex,
} from "@songtradr-one/components-frontend";

// TEXT

// STYLES
export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  /* clip/scroll internally instead of spilling past the floating-ui max-height cap */
  overflow-y: auto;
  z-index: ${zIndex.dropdown};
  box-shadow: ${elevation03};
  /* stop shadow blur bleeding onto the header */
  clip-path: inset(0 -6.25rem -6.25rem -6.25rem);
  margin-top: ${headerHeight};
  background: ${shade950};
`;

// DATA

// TYPES
export type Props = {
  anchor: HTMLElement | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
